import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { piper } from './primitives';

/**
 * PiperActionCard — a prioritized card in the Piper rail.
 * Urgent cards are red-tinted; normal cards are neutral. Actions resolve
 * inline (the parent swaps the card for a ✓ line via onAction).
 */
const PiperActionCard = ({ card, onAction, done }) => {
  if (done) {
    return (
      <Typography sx={{ fontSize: '12px', fontWeight: 600, color: piper.green2, px: 0.5, py: 0.5 }}>
        ✓ {done}
      </Typography>
    );
  }

  const { urgent, title, body, actions = [] } = card;

  return (
    <Box
      sx={{
        borderRadius: `${piper.radius.card}px`,
        border: `1px solid ${urgent ? piper.redTintBorder : piper.hairlineStrong}`,
        backgroundColor: urgent ? piper.redTintBg : piper.surface,
        boxShadow: urgent ? piper.shadow.heroGlow : 'none',
        px: 1.5,
        py: 1.25,
      }}
    >
      <Typography sx={{ fontSize: '12px', fontWeight: 700, color: urgent ? piper.redDark : piper.ink, mb: 0.4 }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: '12px', color: piper.muted, lineHeight: 1.5, mb: actions.length ? 1 : 0 }}>
        {body}
      </Typography>
      {actions.length > 0 && (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
          {actions.map((a) =>
            a.kind === 'tertiary' ? (
              <Link
                key={a.id}
                component="button"
                type="button"
                onClick={() => onAction?.(a)}
                sx={{ fontSize: '11.5px', fontWeight: 700, color: piper.inkSecondary, textDecorationColor: piper.outline }}
              >
                {a.label}
              </Link>
            ) : (
              <Button
                key={a.id}
                size="small"
                variant={a.kind === 'primary' ? 'contained' : 'outlined'}
                onClick={() => onAction?.(a)}
              >
                {a.label}
              </Button>
            ),
          )}
        </Stack>
      )}
    </Box>
  );
};

export default PiperActionCard;
